/* eslint-disable @typescript-eslint/no-unused-vars */
import DesignThumb from '@components/@editor-components/DesignThumb'
import ClassicTextField from '@components/@material-extend/ClassicTextField'
import TableLayout from '@components/@material-extend/TableLayout'
import PaperHeader from '@components/PaperHeader'
import { Side } from '@constants/editor.constants'
import i18n from '@locales/i18n'
import {
  Box,
  Paper,
  Grid,
  FormControl,
  Button,
  Typography,
  ButtonGroup,
  TableCell,
  TableRow,
  MenuItem,
  ListItemText,
  Stack,
  Alert,
  useMediaQuery,
} from '@mui/material'
import { ThemeColors } from '@theme/colors'
import { useState, useEffect, useCallback } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import ClassicSelect from '@components/@material-extend/ClassicSelect'
import _ from 'lodash'
import { use100vh } from 'react-div-100vh'
import { LayoutContants } from '@constants/layout.constants'
import useDesign from '@containers/EditorContainer/useDesign'
import useOrder from '@containers/OrderContainer/useOrder'
import Spinner from '@components/@material-extend/Spinner'
import customHistory from 'customHistory'
import useDesignForm from './useDesignForm'
import { useConfirm } from '@components/Confirm'
import useShareForm from './useShareForm'
import { LoadingButton } from '@mui/lab'
import { DesignMarking } from '@services/design.services'
import { FieldValues } from 'react-hook-form'
import PaperHeaderReverse from '@components/PaperHeader/PaperHeaderReverse'
import { ArrowBack, ArrowLeft } from '@mui/icons-material'
import { MARKING_TYPE } from '@constants/common.constants'
import HorizontalTextField from '@components/@material-extend/HorizontalTextField'
import CurrencyInput from '@components/CurrencyInput'

const DesignConfirm = () => {
  const [compare, onChangeCompare] = useState<string>('')
  const [side, onChangeSide] = useState<Side>(Side.Front)
  const [count, onChangeCount] = useState<any>(1)
  const [row, setRow] = useState<any>(0)
  const [search, setSearchParams] = useSearchParams()
  const { showOrder, order } = useOrder()

  const height = use100vh()

  useEffect(() => {
    const newVal = parseInt(row)
    const oldVal = fields.length
    if (newVal > oldVal) {
      for (let i = oldVal; i < newVal; i++) {
        append(
          { tops_size: '', bottoms_size: '', marking_values: [] },
          { shouldFocus: false }
        )
      }
    } else {
      for (let i = oldVal; i > newVal; i--) {
        remove(i - 1)
      }
    }
  }, [row])

  useEffect(() => {
    if (search.get('order')) {
      showOrder({ code: search.get('order') as string })
    }
  }, [search])

  const { data, showDetail, metaDetail, toast, share, metaShare } = useDesign()
  const { create, metaCreate, clear } = useOrder()
  const isMobile = useMediaQuery('(max-width:900px)')
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      showDetail(id)
    }
  }, [id, search])

  const top = _.find(
    data?.attributes.design_items,
    (item) => item.attributes.genre_type === 1
  )
  const bottom = _.find(
    data?.attributes.design_items,
    (item) => item.attributes.genre_type === 2
  )

  const topActiveMarking = top
    ? _.filter(
        top.attributes.design_markings,
        (m) => m.attributes.is_common === false
      )
    : []

  const bottomActiveMarking = bottom
    ? _.filter(
        bottom.attributes.design_markings,
        (m) => m.attributes.is_common === false
      )
    : []

  const topAllMarkings = top ? top.attributes.item_markings : []
  const bottomAllMarkings = bottom ? bottom.attributes.item_markings : []
  const allMarkings = topAllMarkings.concat(bottomAllMarkings)

  const {
    fields,
    append,
    remove,
    errors,
    Controller,
    control,
    reset,
    trigger,
    handleSubmit,
  } = useDesignForm(top, bottom, allMarkings)

  const { Controller: ControllerEmail, methods: methodsEmail } = useShareForm()

  const fillHeight = height ? height - LayoutContants.appbarHeight - 96 : '100%'
  const tableHeight = height
    ? height - LayoutContants.appbarHeight - 380
    : '300px'

  const isEmptyAllFields =
    _.isEmpty(top?.attributes.size) &&
    _.isEmpty(bottom?.attributes.size) &&
    top &&
    bottom

  useEffect(() => {
    if (order && search.get('order')) {
      const transform = _.map(order.attributes.details, (o) => {
        return {
          ..._.omit(o.attributes, 'set_order'),
        }
      })
      reset({ orders: transform })
      trigger('orders')
      onChangeCount(order.attributes.details.length)
    }
  }, [order])

  useEffect(() => {
    if (!search.get('order')) {
      clear()
      reset({})
      onChangeCount(1)
      delayedRowChange(1)
      // eslint-disable-next-line no-console
    }
  }, [search])

  const {
    control: controlEmail,
    handleSubmit: handleSubmitEmail,
    formState: {
      errors: errorsEmail,
      isValid: isValidEmail,
      isDirty: isDirtyEmail,
    },
    reset: resetEmail,
  } = methodsEmail

  const topSvg =
    side === Side.Front ? top?.attributes.front_url : top?.attributes.back_url

  const bottomSvg =
    side === Side.Front
      ? bottom?.attributes.front_url
      : bottom?.attributes.back_url

  const confirm = useConfirm()

  const onSubmit = (data: any, type?: string) => {
    // eslint-disable-next-line no-console

    const transformOrder = _.map(data.orders, (o, i) => {
      return { ...o, set_order: i }
    })

    if (id) {
      confirm({
        title: i18n.t('orders.check_order_title'),
        description: i18n.t('orders.check_order_desc'),
      })
        .then(() => {
          if (type) {
            create({
              design_code: id,
              details: transformOrder,
              type: type,
            })
          } else {
            create({
              design_code: id,
              details: transformOrder,
            })
          }
        })
        .catch(() => null)
    }
  }

  const handleCompare = () => {
    if (!_.isEmpty(compare)) {
      customHistory.push(`/compare?a=${id}&b=${compare}`)
    }
  }

  const renderLoader = () => {
    if (!data && metaDetail.loaded && !metaDetail.pending) {
      return (
        <Box sx={{ width: '100%', height: 400 }}>
          <Spinner loading={true} />
        </Box>
      )
    }
  }

  const handleChangeMarking = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    value: any[],
    detail: DesignMarking,
    callback: (value: any) => void
  ) => {
    const filterMarking = _.filter(value, (v) => v.marking_id !== detail.id)
    const data = [
      ...filterMarking,
      {
        marking_id: detail.id,
        value: event.target.value,
        item_marking_id: detail.attributes.item_marking_id,
      },
    ]
    callback(data)
  }

  const renderRowMobile = (_item: any, index: number) => {
    return (
      <Box sx={{ width: '100%', display: 'block', mb: 4 }}>
        <Box
          sx={{
            padding: 1,
            background: '#cecece',
            borderRadius: 2,
            width: '100%',
            textAlign: 'center',
            height: 34,
            mb: 1,
          }}
        >
          {index + 1}
        </Box>
        <Stack
          mb={1}
          sx={{ background: ThemeColors.primary, color: '#fff', p: 1 }}
          direction={'row'}
          justifyContent={'space-between'}
        >
          {top && !_.isEmpty(top.attributes.size) ? (
            <Box
              sx={{
                borderRight: '1px solid #eee',
                width: '100%',
                textAlign: 'center',
              }}
            >
              サイズ ({i18n.t('SYSCOMMON.tops')})
            </Box>
          ) : null}
          {bottom && !_.isEmpty(bottom.attributes.size) ? (
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              サイズ ({i18n.t('SYSCOMMON.bottoms')})
            </Box>
          ) : null}
        </Stack>

        <Stack
          direction={'row'}
          spacing={1}
          mb={1}
          justifyContent={'space-between'}
        >
          {top && !_.isEmpty(top.attributes.size) ? (
            <Box sx={{ width: '100%' }}>
              <Controller
                name={`orders.${index}.tops_size`}
                control={control}
                render={({ field: { value, onChange, ref } }: FieldValues) => (
                  <Box sx={{ width: !isMobile ? 140 : '100%' }}>
                    <ClassicSelect
                      id={`orders.${index}.tops_size`}
                      inputProps={{ sx: { background: '#fff' } }}
                      helperText={
                        errors?.orders?.[index]?.tops_size
                          ? i18n.t('orders.size_required')
                          : ''
                      }
                      value={value}
                      error={errors?.orders?.[index]?.tops_size ? true : false}
                      onChange={onChange}
                      inputRef={ref}
                    >
                      {!_.isEmpty(top.attributes.size) ? (
                        top.attributes.size.map((item, k) => (
                          <MenuItem key={k} value={item}>
                            <ListItemText primary={`${item}サイズ`} />
                          </MenuItem>
                        ))
                      ) : (
                        <Typography>{i18n.t('orders.no_size')}</Typography>
                      )}
                    </ClassicSelect>
                  </Box>
                )}
              />
            </Box>
          ) : null}
          {bottom && !_.isEmpty(bottom.attributes.size) ? (
            <Box sx={{ width: '100%' }}>
              <Controller
                name={`orders.${index}.bottoms_size`}
                control={control}
                render={({ field: { value, onChange, ref } }: FieldValues) => (
                  <Box sx={{ width: !isMobile ? 140 : '100%' }}>
                    <ClassicSelect
                      id={`orders.${index}.bottoms_size`}
                      helperText={
                        errors?.orders?.[index]?.bottoms_size
                          ? i18n.t('orders.size_required')
                          : ''
                      }
                      value={value}
                      error={
                        errors?.orders?.[index]?.bottoms_size ? true : false
                      }
                      inputRef={ref}
                      onChange={onChange}
                    >
                      {!_.isEmpty(bottom.attributes.size) ? (
                        bottom.attributes.size.map((item, k) => (
                          <MenuItem key={k} value={item}>
                            <ListItemText primary={`${item}サイズ`} />
                          </MenuItem>
                        ))
                      ) : (
                        <Typography>{i18n.t('orders.no_size')}</Typography>
                      )}
                    </ClassicSelect>
                  </Box>
                )}
              />
            </Box>
          ) : null}
        </Stack>

        {top
          ? topActiveMarking.map((d) => {
              return (
                <>
                  <Box
                    sx={{
                      background: ThemeColors.primary,
                      color: '#fff',
                      p: 1,
                      mb: 1,
                    }}
                  >
                    {
                      _.find(top.attributes.item_markings, {
                        id: d.attributes.item_marking_id.toString(),
                      })?.attributes.name
                    }
                  </Box>
                  <Box
                    key={d.id}
                    sx={{
                      height: 50,
                      mt: 1,
                      maxWidth: !isMobile ? '200px' : '100%',
                      width: '100%',
                    }}
                  >
                    <Controller
                      name={`orders.${index}.marking_values`}
                      control={control}
                      render={({
                        field: { value, onChange, ref },
                      }: FieldValues) => (
                        <ClassicTextField
                          error={errors?.orders?.[index]?.marking_values}
                          inputRef={ref}
                          helperText={
                            errors?.orders?.[index]?.marking_values.message
                          }
                          fullWidth
                          value={_.find(value, { marking_id: d.id })?.value}
                          onChange={(v) =>
                            handleChangeMarking(v, value, d, onChange)
                          }
                        />
                      )}
                    />
                  </Box>
                </>
              )
            })
          : null}

        {bottom
          ? bottomActiveMarking.map((d) => {
              return (
                <>
                  <Box
                    sx={{
                      background: ThemeColors.primary,
                      color: '#fff',
                      p: 1,
                      mb: 1,
                    }}
                  >
                    {
                      _.find(bottom.attributes.item_markings, {
                        id: d.attributes.item_marking_id.toString(),
                      })?.attributes.name
                    }
                  </Box>
                  <Box
                    key={d.id}
                    sx={{
                      height: 50,
                      mt: 1,
                      maxWidth: !isMobile ? '200px' : '100%',
                      width: '100%',
                    }}
                  >
                    <Controller
                      name={`orders.${index}.marking_values`}
                      control={control}
                      render={({
                        field: { value, onChange, ref },
                      }: FieldValues) => (
                        <ClassicTextField
                          inputRef={ref}
                          helperText={
                            errors?.orders?.[index]?.marking_values.message
                          }
                          error={errors?.orders?.[index]?.marking_values}
                          fullWidth
                          value={_.find(value, { marking_id: d.id })?.value}
                          onChange={(v) =>
                            handleChangeMarking(v, value, d, onChange)
                          }
                        />
                      )}
                    />
                  </Box>
                </>
              )
            })
          : null}
      </Box>
    )
  }

  const renderRow = (_item: any, index: number) => {
    return (
      <TableRow
        key={index}
        sx={{ background: errors?.orders?.[index] ? '#eee' : '' }}
      >
        <TableCell align="center" width={60}>
          <Box
            sx={{
              padding: 1,
              background: '#eee',
              borderRadius: 3,
              width: 40,
              height: 40,
              margin: '0 auto',
            }}
          >
            {index + 1}
          </Box>
        </TableCell>
        {top && !_.isEmpty(top.attributes.size) ? (
          <TableCell align="center">
            <Box sx={{ height: 50, mt: 1 }}>
              <Controller
                name={`orders.${index}.tops_size`}
                control={control}
                render={({ field: { value, onChange, ref } }: FieldValues) => (
                  <Box sx={{ width: '100%' }}>
                    <ClassicSelect
                      id={`orders.${index}.tops_size`}
                      inputProps={{ sx: { background: '#fff' } }}
                      helperText={
                        errors?.orders?.[index]?.tops_size
                          ? i18n.t('orders.size_required')
                          : ''
                      }
                      value={value}
                      error={errors?.orders?.[index]?.tops_size ? true : false}
                      onChange={onChange}
                      inputRef={ref}
                    >
                      {!_.isEmpty(top.attributes.size) ? (
                        top.attributes.size.map((item, k) => (
                          <MenuItem key={k} value={item}>
                            <ListItemText primary={`${item}サイズ`} />
                          </MenuItem>
                        ))
                      ) : (
                        <Typography>{i18n.t('orders.no_size')}</Typography>
                      )}
                    </ClassicSelect>
                  </Box>
                )}
              />
            </Box>
          </TableCell>
        ) : null}
        {bottom && !_.isEmpty(bottom.attributes.size) ? (
          <TableCell align="center">
            <Box sx={{ height: 50, mt: 1 }}>
              <Controller
                name={`orders.${index}.bottoms_size`}
                control={control}
                render={({ field: { value, onChange, ref } }: FieldValues) => (
                  <Box sx={{ width: '100%' }}>
                    <ClassicSelect
                      id={`orders.${index}.bottoms_size`}
                      helperText={
                        errors?.orders?.[index]?.bottoms_size
                          ? i18n.t('orders.size_required')
                          : ''
                      }
                      value={value}
                      error={
                        errors?.orders?.[index]?.bottoms_size ? true : false
                      }
                      inputRef={ref}
                      onChange={onChange}
                    >
                      {!_.isEmpty(bottom.attributes.size) ? (
                        bottom.attributes.size.map((item, k) => (
                          <MenuItem key={k} value={item}>
                            <ListItemText primary={`${item}サイズ`} />
                          </MenuItem>
                        ))
                      ) : (
                        <Typography>{i18n.t('orders.no_size')}</Typography>
                      )}
                    </ClassicSelect>
                  </Box>
                )}
              />
            </Box>
          </TableCell>
        ) : null}

        {top
          ? topActiveMarking.map((d) => {
              return (
                <TableCell
                  key={d.id}
                  scope="row"
                  align="center"
                  sx={{ position: 'relative' }}
                >
                  <Box sx={{ height: 50, mt: 1, width: '100%' }}>
                    <Controller
                      name={`orders.${index}.marking_values`}
                      control={control}
                      render={({
                        field: { value, onChange, ref },
                      }: FieldValues) => (
                        <ClassicTextField
                          error={errors?.orders?.[index]?.marking_values}
                          inputRef={ref}
                          helperText={
                            errors?.orders?.[index]?.marking_values.message
                          }
                          fullWidth
                          value={_.find(value, { marking_id: d.id })?.value}
                          onChange={(v) =>
                            handleChangeMarking(v, value, d, onChange)
                          }
                        />
                      )}
                    />
                  </Box>
                </TableCell>
              )
            })
          : null}

        {bottom
          ? bottomActiveMarking.map((d) => {
              return (
                <TableCell
                  key={d.id}
                  scope="row"
                  align="center"
                  sx={{ position: 'relative' }}
                >
                  <Box sx={{ height: 50, mt: 1, width: '100%' }}>
                    <Controller
                      name={`orders.${index}.marking_values`}
                      control={control}
                      render={({
                        field: { value, onChange, ref },
                      }: FieldValues) => (
                        <ClassicTextField
                          inputRef={ref}
                          error={errors?.orders?.[index]?.marking_values}
                          fullWidth
                          helperText={
                            errors?.orders?.[index]?.marking_values.message
                          }
                          value={_.find(value, { marking_id: d.id })?.value}
                          onChange={(v) =>
                            handleChangeMarking(v, value, d, onChange)
                          }
                        />
                      )}
                    />
                  </Box>
                </TableCell>
              )
            })
          : null}
      </TableRow>
    )
  }

  const delayedRowChange = useCallback(
    _.debounce((q) => setRow(q), 500),
    []
  )

  const handleCountRow = (value: string) => {
    onChangeCount(value)
    delayedRowChange(value)
  }

  const onClickDetail = () => null

  const onSubmitEmail = (values: any) => {
    if (id && values.email) {
      share({
        code: id,
        email: values.email,
      })
    }
  }

  return (
    <>
      <Box>
        {data ? (
          <Grid container spacing={2} sx={{ minHeight: fillHeight }}>
            <Grid item md={6} sm={12} xs={12}>
              <Paper sx={{ mt: 2, height: '100%' }}>
                {data.attributes.is_expired ? (
                  <Box mt={1}>
                    <Alert severity="warning">{i18n.t('ERROR.BE000007')}</Alert>
                  </Box>
                ) : null}
                <PaperHeaderReverse
                  title={i18n.t('SYSCOMMON.design_preview')}
                  actions={
                    <>
                      <Button
                        startIcon={<ArrowBack />}
                        disabled={
                          !data.attributes.is_active ||
                          data.attributes.is_expired
                        }
                        sx={{ mt: 0.5 }}
                        variant="contained"
                        size="small"
                      >
                        <Link
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          to={`/editor?copy=${id}`}
                        >
                          {!isMobile
                            ? i18n.t('designs.design_correction')
                            : '修正'}
                        </Link>
                      </Button>
                    </>
                  }
                />
                <Grid container>
                  <Grid xs={12} item>
                    <Box
                      sx={{
                        overflow: 'hidden',
                      }}
                    >
                      <Stack
                        direction={{
                          md: 'row',
                          lg: 'row',
                          xl: 'row',
                          sm: 'column',
                          xs: 'column',
                        }}
                        justifyContent={'space-around'}
                        spacing={1}
                      >
                        {!_.isEmpty(top) && (
                          <Box
                            sx={{
                              p: {
                                xs: 0,
                                sm: 0,
                                md: 2,
                              },
                              width: 340,
                              margin: {
                                sm: '0 auto',
                                xs: '0 auto',
                              },
                            }}
                          >
                            <Box
                              sx={{
                                width: '100%',
                                border: {
                                  xs: '0 none',
                                  sm: '0 none',
                                  md: '2px solid #eee',
                                },
                              }}
                            >
                              <DesignThumb
                                width={'340'}
                                ratioHeight="80%"
                                sx={{
                                  position: 'relative',
                                  height: {
                                    xs: '100%',
                                    sm: '100%',
                                  },
                                  width: '100%',
                                }}
                                svg={topSvg ? topSvg : ''}
                              />
                            </Box>
                            <Box
                              sx={{
                                textAlign: 'center',
                                mt: 1,
                              }}
                            >
                              <Box onClick={() => onClickDetail()}>
                                <Typography
                                  variant="h5"
                                  sx={{
                                    display: '-webkit-box',
                                    margin: '0 auto',
                                    WebkitLineClamp: '2',
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: 'center',
                                    height: 20,
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    '&:hover': {
                                      transition: 'all 0.3s ease',
                                      color: ThemeColors.secondary,
                                    },
                                  }}
                                  component="div"
                                >
                                  {top?.attributes.name}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        )}

                        {!_.isEmpty(bottom) && (
                          <Box
                            sx={{
                              p: {
                                xs: 0,
                                sm: 0,
                                md: 2,
                              },
                              width: 340,
                              margin: {
                                sm: '0 auto !important',
                                xs: '0 auto !important',
                              },
                            }}
                          >
                            <Box
                              sx={{
                                width: '100%',
                                border: {
                                  xs: '0 none',
                                  sm: '0 none',
                                  md: '2px solid #eee',
                                },
                                height: {
                                  md: 'auto',
                                },
                              }}
                            >
                              <DesignThumb
                                ratioHeight="80%"
                                svg={bottomSvg ? bottomSvg : ''}
                                sx={{
                                  position: 'relative',
                                  height: {
                                    xs: '100%',
                                    sm: '100%',
                                  },
                                  width: '100%',
                                }}
                              />
                            </Box>
                            <Box
                              sx={{
                                textAlign: 'center',
                                mt: 1,
                              }}
                            >
                              <Box onClick={() => onClickDetail()}>
                                <Typography
                                  variant="h5"
                                  sx={{
                                    display: '-webkit-box',
                                    margin: '0 auto',
                                    WebkitLineClamp: '2',
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: 'center',
                                    height: 20,
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    '&:hover': {
                                      transition: 'all 0.3s ease',
                                      color: ThemeColors.secondary,
                                    },
                                  }}
                                  component="div"
                                >
                                  {bottom?.attributes.name}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        )}
                      </Stack>
                    </Box>
                    <Box sx={{ textAlign: 'center', pb: 2, pt: 1 }}>
                      <Box
                        sx={{
                          border: '1px solid #ccc',
                          width: 210,
                          margin: '0 auto',
                        }}
                      >
                        <ButtonGroup sx={{ p: 0.5, background: '#fff' }}>
                          <Button
                            onClick={() => onChangeSide(Side.Front)}
                            disableRipple
                            className={side === Side.Front ? 'is-active' : ''}
                            variant="outlined"
                            sx={{
                              color: '#222',
                              borderColor: '#999',
                              border: '0 none',
                              width: 100,
                              '&:hover': {
                                border: '0 none',
                              },
                              '&.is-active': {
                                color: '#fff',
                                background: ThemeColors.primary,
                              },
                            }}
                          >
                            {i18n.t('SYSCOMMON.front')}
                          </Button>
                          <Button
                            onClick={() => onChangeSide(Side.Back)}
                            disableRipple
                            className={side === Side.Back ? 'is-active' : ''}
                            sx={{
                              color: '#222',
                              border: '0 none',
                              width: 100,
                              '&.is-active': {
                                color: '#fff',
                                background: ThemeColors.primary,
                              },
                              '&:hover': {
                                border: '0 none',
                              },
                            }}
                          >
                            {i18n.t('SYSCOMMON.back')}
                          </Button>
                        </ButtonGroup>
                      </Box>
                    </Box>
                  </Grid>

                  <Box
                    sx={{
                      p: 2,
                      pl: {
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 4,
                      },
                      pr: {
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 4,
                      },
                    }}
                  >
                    <FormControl sx={{ mb: { sm: 2, xs: 2, md: 1 } }} fullWidth>
                      <Grid container spacing={2} alignItems={'flex-end'}>
                        <Grid item xs={12} sm={12} md={9}>
                          <ClassicTextField
                            fullWidth
                            label="デザイン案コード"
                            readOnly
                            value={`${id}`}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={3}
                          display={'flex'}
                          justifyContent={'center'}
                        >
                          <Button
                            sx={{ maxWidth: 200 }}
                            fullWidth
                            variant="contained"
                          >
                            印刷
                          </Button>
                        </Grid>
                      </Grid>
                    </FormControl>
                    <FormControl sx={{ mb: { sm: 2, xs: 2, md: 1 } }} fullWidth>
                      <Grid
                        container
                        spacing={2}
                        alignItems={{
                          xs: 'center',
                          sm: 'center',
                          md: 'flex-end',
                        }}
                      >
                        <Grid item xs={12} sm={12} md={9}>
                          <ClassicTextField
                            readOnly
                            value={`${window.location.href}`}
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={3}
                          display={'flex'}
                          justifyContent={'center'}
                        >
                          <Button
                            fullWidth
                            sx={{ maxWidth: 200 }}
                            onClick={() => {
                              toast({
                                message: i18n.t('designs.copy_to_clipboard'),
                              })
                              navigator.clipboard.writeText(
                                `${window.location.href}`
                              )
                            }}
                            variant="contained"
                          >
                            URLコピー
                          </Button>
                        </Grid>
                      </Grid>
                    </FormControl>
                    <FormControl sx={{ mb: { sm: 2, xs: 2, md: 1 } }} fullWidth>
                      <form
                        id="share-email"
                        onSubmit={handleSubmitEmail(onSubmitEmail)}
                      >
                        <Grid container spacing={2} alignItems={'flex-end'}>
                          <Grid item xs={12} sm={12} md={9}>
                            <ControllerEmail
                              name={'email'}
                              control={controlEmail}
                              render={({
                                field: { value, onChange, ref },
                              }: FieldValues) => (
                                <ClassicTextField
                                  error={!!errorsEmail.email?.message}
                                  helperText={
                                    errorsEmail?.email
                                      ? errorsEmail.email?.message
                                      : ''
                                  }
                                  inputRef={ref}
                                  fullWidth
                                  value={value}
                                  placeholder="メールアドレス"
                                  onChange={(v) => onChange(v)}
                                />
                              )}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={3}
                            display={'flex'}
                            justifyContent={'center'}
                          >
                            <LoadingButton
                              fullWidth
                              type="submit"
                              sx={{ height: 36, maxWidth: 200 }}
                              variant="contained"
                              loading={metaShare.pending}
                              disabled={
                                !isValidEmail ||
                                !isDirtyEmail ||
                                metaShare.pending ||
                                data.attributes.is_expired
                              }
                            >
                              送信
                            </LoadingButton>
                          </Grid>
                        </Grid>
                      </form>
                    </FormControl>
                    <FormControl sx={{ mb: { sm: 2, xs: 2, md: 1 } }} fullWidth>
                      <Grid container spacing={2} alignItems={'flex-end'}>
                        <Grid item xs={12} sm={12} md={9}>
                          <ClassicTextField
                            value={compare}
                            placeholder="他のデザイン案コード"
                            onChange={(e) => onChangeCompare(e.target.value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={3}
                          display={'flex'}
                          justifyContent={'center'}
                        >
                          <Button
                            disabled={_.isEmpty(compare)}
                            onClick={() => handleCompare()}
                            variant="contained"
                            fullWidth
                            sx={{ maxWidth: 200 }}
                          >
                            比較
                          </Button>
                        </Grid>
                      </Grid>
                    </FormControl>
                    {/* <Divider sx={{ pt: 1, pb: 1 }}> 共通マーキング設定内容</Divider>
              <Typography variant="h5" sx={{ mt: 1, mb: 1 }}></Typography>
              <FormControl sx={{ mb: 1 }} fullWidth>
                <ClassicTextField
                  value={'Team Name'}
                  label="チーム名"
                  readOnly
                  onChange={(e) => onChangeCompare(e.target.value)}
                  fullWidth
                />
              </FormControl>
              <FormControl>
                <Label>ロゴ</Label>
                <Box
                  component="img"
                  sx={{
                    width: 150,
                    height: 'auto',
                    border: '1px solid #eee',
                  }}
                  src="/sample/team-logo.png"
                />
              </FormControl> */}
                  </Box>
                </Grid>
              </Paper>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <Paper sx={{ mt: 2, height: '100%' }}>
                <PaperHeaderReverse title={i18n.t('SYSCOMMON.settings')} />
                <Box
                  sx={{
                    p: { xs: 1, sm: 2, md: 4 },
                    paddingBottom: '0 !important',
                  }}
                >
                  <Box sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <ClassicTextField
                            label="セット数"
                            value={count}
                            type="number"
                            onChange={(e) => handleCountRow(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <ClassicTextField
                            fullWidth
                            label="合計金額"
                            inputProps={{
                              sx: {
                                textAlign: 'right',
                              },
                            }}
                            readOnly
                            value={`${
                              Number(count) * data.attributes.price
                            }円 `}
                          />
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Box>

                  <form
                    onSubmit={handleSubmit((data) => {
                      onSubmit(data)
                    })}
                  >
                    {metaCreate.error && (
                      <Box mt={1}>
                        <Alert severity="warning">
                          {i18n.t('SYSCOMMON.E000003')}
                        </Alert>
                      </Box>
                    )}
                    <Box
                      className="scroll-container"
                      sx={{
                        display: 'flex',
                        height: !isMobile ? tableHeight : 'auto',
                        overflowY: 'auto',
                        border: !isMobile ? '1px solid #eee' : '0 none',
                      }}
                    >
                      {!isMobile && isEmptyAllFields !== undefined ? (
                        <TableLayout
                          paperProps={{
                            sx: {
                              boxShadow: 'none',
                              background: '#fefefe',
                              width: '100%',
                            },
                          }}
                          renderRow={renderRow}
                          data={fields}
                          minWidth={'100%'}
                          head={
                            <TableRow
                              sx={{
                                '& .MuiTableCell-head': {
                                  background: '#222',
                                  color: '#fff !important',
                                  borderRight: '1px solid #fff',
                                },
                              }}
                            >
                              <TableCell align="center" />
                              {top && !_.isEmpty(top.attributes.size) ? (
                                <TableCell
                                  align="center"
                                  sx={{ minWidth: 180 }}
                                >
                                  サイズ ({i18n.t('SYSCOMMON.tops')})
                                </TableCell>
                              ) : null}
                              {bottom && !_.isEmpty(bottom.attributes.size) ? (
                                <TableCell
                                  align="center"
                                  sx={{ minWidth: 180 }}
                                >
                                  サイズ ({i18n.t('SYSCOMMON.bottoms')})
                                </TableCell>
                              ) : null}

                              {top
                                ? topActiveMarking.map((d) => {
                                    return (
                                      <TableCell
                                        key={d.id}
                                        align="center"
                                        sx={{ minWidth: 180 }}
                                      >
                                        {
                                          _.find(top.attributes.item_markings, {
                                            id: d.attributes.item_marking_id.toString(),
                                          })?.attributes.name
                                        }
                                      </TableCell>
                                    )
                                  })
                                : null}

                              {bottom
                                ? bottomActiveMarking.map((d) => {
                                    return (
                                      <TableCell
                                        key={d.id}
                                        align="center"
                                        sx={{ minWidth: 180 }}
                                      >
                                        {
                                          _.find(
                                            bottom.attributes.item_markings,
                                            {
                                              id: d.attributes.item_marking_id.toString(),
                                            }
                                          )?.attributes.name
                                        }
                                      </TableCell>
                                    )
                                  })
                                : null}
                            </TableRow>
                          }
                        />
                      ) : isEmptyAllFields !== undefined ? (
                        <Box sx={{ width: '100%' }}>
                          {_.map(fields, (item, index) => {
                            return renderRowMobile(item, index)
                          })}
                        </Box>
                      ) : null}
                    </Box>

                    <Stack
                      direction={{ xs: 'column', sm: 'column', md: 'row' }}
                      justifyContent="space-around"
                      spacing={2}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 2,
                        mt: 2,
                        p: 0,
                      }}
                    >
                      <Button
                        type={'submit'}
                        sx={{ minWidth: 200 }}
                        variant="contained"
                        size="large"
                        fullWidth
                        startIcon={
                          <Box
                            sx={{
                              width: 13,
                              height: 13,
                              mr: 1,
                              position: 'relative',
                              top: '-17px',
                            }}
                          >
                            <Box
                              sx={{ width: '100%', height: 'auto' }}
                              component="img"
                              src="/images/ribonicon.png"
                            ></Box>
                          </Box>
                        }
                        disabled={
                          data.attributes.is_expired || !_.isEmpty(errors)
                        }
                        color="secondary"
                      >
                        {i18n.t('orders.save_order')}
                      </Button>
                      <Button
                        // eslint-disable-next-line no-console
                        onClick={handleSubmit((d) => onSubmit(d, 'EC'))}
                        sx={{
                          minWidth: 200,
                          width: !isMobile ? 'auto' : '100%',
                        }}
                        variant="contained"
                        size="large"
                        disabled={
                          data.attributes.is_expired || !_.isEmpty(errors)
                        }
                        color="primary"
                      >
                        {i18n.t('SYSCOMMON.ec_button')}
                      </Button>
                    </Stack>
                  </form>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        ) : null}
        {renderLoader()}
      </Box>
    </>
  )
}

export default DesignConfirm
